import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TReportingPeriodApplicantDocument {
  documentId: number;
  documentRelation: string;
  name: string;
  reportingPeriodApplicantId: number;
  valid: boolean;
  document: any;
}

export interface IReportingPeriodApplicantDocument
  extends TReportingPeriodApplicantDocument {}

const ReportingPeriodApplicantDocument = Model(
  (
    model: TReportingPeriodApplicantDocument
  ): IReportingPeriodApplicantDocument => {
    const _reportingPeriodApplicantDocument: TReportingPeriodApplicantDocument = Object.assign(
      {},
      model
    );

    let create = (
      reportingPeriodApplicantDocument: IReportingPeriodApplicantDocument
    ): IReportingPeriodApplicantDocument => {
      let obj = ValidatableObject(reportingPeriodApplicantDocument);
      return obj;
    };

    let reportingPeriodApplicantDocument = {
      get documentId() {
        return _reportingPeriodApplicantDocument.documentId;
      },
      set documentId(value) {
        _reportingPeriodApplicantDocument.documentId = value;
      },
      get documentRelation() {
        return _reportingPeriodApplicantDocument.documentRelation;
      },
      set documentRelation(value) {
        _reportingPeriodApplicantDocument.documentRelation = value;
      },
      get name() {
        return _reportingPeriodApplicantDocument.name;
      },
      set name(value) {
        _reportingPeriodApplicantDocument.name = value;
      },
      get reportingPeriodApplicantId() {
        return _reportingPeriodApplicantDocument.reportingPeriodApplicantId;
      },
      set reportingPeriodApplicantId(value) {
        _reportingPeriodApplicantDocument.reportingPeriodApplicantId = value;
      },
      get valid() {
        return _reportingPeriodApplicantDocument.valid;
      },
      set valid(value) {
        _reportingPeriodApplicantDocument.valid = value;
      },
      get document() {
        return _reportingPeriodApplicantDocument.document;
      },
      set document(value) {
        _reportingPeriodApplicantDocument.document = value;
      }
    };
    return create(reportingPeriodApplicantDocument);
  }
);

export default ReportingPeriodApplicantDocument;
